const MIME_TYPES = {
  pdf: 'application/pdf',
  xlsx: 'application/vnd.ms-excel',
  csv: 'text/comma-separated-values',
  json: 'application/json',
};

export default MIME_TYPES;
